import { Form, Input } from "antd";
import { formatToCurrencyType } from "helper/common";
import { ColumnsEdit } from "types/models/column-table-edit";
import React from "react";

const allColumns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    width: "5%",
    align: "center",
    fixed: true,
    render: (v, r, i) => i + 1,
  },
  {
    title: "Mã",
    dataIndex: "",
    key: "",
    align: "left",
    width: "5%",
  },
  {
    title: "Tên gói DV",
    dataIndex: "tenGoiDichVu",
    key: "tenGoiDichVu",
    align: "left",
    width: "25%",
  },
  {
    title: "Giá BV",
    dataIndex: "giaBv",
    key: "giaBv",
    align: "right",
    width: "10%",
    render: (v) => formatToCurrencyType(v),
  },
  {
    title: "BH trả",
    dataIndex: "giaBH",
    key: "giaBH",
    align: "right",
    width: "10%",
    render: (v) => formatToCurrencyType(v),
  },
  {
    title: "Mô tả",
    dataIndex: "maBenhNhan",
    key: "maBenhNhan",
    align: "left",
    width: "30%",
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    key: "trangThai",
    align: "left",
    width: "15%",
  },
];
const width = "20%";
const allColumnsBHYT: ColumnsEdit = [
  {
    title: "Mức bảo hiểm",
    dataIndex: "mucBH",
    key: "mucBH",
    align: "left",
    width: width,
  },
  {
    title: "Giá BH",
    dataIndex: "giaBHYT",
    key: "giaBHYT",
    align: "right",
    width: width,
    render: (v) => formatToCurrencyType(v),
  },
  {
    title: "NB đồng chi trả",
    dataIndex: "nbDongChiTra",
    key: "nbDongChiTra",
    align: "right",
    width: width,
  },
  {
    title: "NB tự trả",
    dataIndex: "nbTuTra",
    key: "nbTuTra",
    align: "right",
    width: width,
  },
  {
    title: "Tổng NB trả",
    dataIndex: "tongnbTra",
    key: "tongnbTra",
    align: "right",
    width: width,
  },
];

const allColumnsTPTG: ColumnsEdit = [
  {
    dataIndex: "STT",
    title: "STT",
    key:'stt',
    render: (v, r, i) => i + 1,
  },
  {
    title: "Nhóm",
    dataIndex: "nhom",
    key: "nhom",
    align: "center",
    width: "15%",
  },
  {
    title: "Tên thành phần",
    dataIndex: "tenThanhPhan",
    key: "tenThanhPhan",
    align: "left",
    width: "20%",
  },
  {
    title: "Giá BV",
    dataIndex: "giaBv",
    key: "giaBv",
    align: "right",
    render: (v) => formatToCurrencyType(v),
    width: "15%",
  },
  {
    title: "Giá BHYT",
    dataIndex: "giaBHYT",
    key: "giaBHYT",
    align: "right",
    width: "15%",
    render: (v) => formatToCurrencyType(v),
  },
  {
    title: "Ghi chú",
    dataIndex: "ghiChu",
    key: "ghiChu",
    align: "left",
    width: "35%",
  },
];

const dataBHYT = [
  {
    key: 1,
    mucBH: "",
    giaBHYT: "0",
    nbDongChiTra: "0",
    nbTuTra: "0",
    tongnbTra: "0",
  },
  {
    key: 2,
    mucBH: "",
    giaBHYT: "0",
    nbDongChiTra: "0",
    nbTuTra: "0",
    tongnbTra: "0",
  },
  {
    key: 3,
    mucBH: "",
    giaBHYT: "0",
    nbDongChiTra: "0",
    nbTuTra: "0",
    tongnbTra: "0",
  },
  {
    key: 4,
    mucBH: "",
    giaBHYT: "0",
    nbDongChiTra: "0",
    nbTuTra: "0",
    tongnbTra: "0",
  },
];
export { allColumns, allColumnsBHYT, allColumnsTPTG, dataBHYT };
